import { jsx as _jsx } from "react/jsx-runtime";
import { Coffee, CreditCard, Film, Fuel, Gift, Plane, ShoppingBag, ShoppingCart, Ticket, UtensilsCrossed } from 'lucide-react';
import { DEMO_BANNER } from '../lib/rewards';
/** Contract kinds: visa | dining | fuel | grocery | retail | experience | other (plus a few synonyms). */
const KIND_ICONS = {
    visa: CreditCard,
    grocery: ShoppingCart,
    experience: Ticket,
    supermarket: ShoppingCart,
    groceries: ShoppingCart,
    fuel: Fuel,
    dining: UtensilsCrossed,
    restaurant: UtensilsCrossed,
    cafe: Coffee,
    coffee: Coffee,
    retail: ShoppingBag,
    shopping: ShoppingBag,
    travel: Plane,
    entertainment: Film,
    movies: Film,
};
export function iconForKind(kind) {
    return (kind && KIND_ICONS[kind.toLowerCase()]) || Gift;
}
/** Shown on every rewards screen while cards are simulated. */
export const DemoBanner = () => (_jsx("div", { role: "note", className: "rounded-card-xs border border-warning-outline bg-warning-container px-4 py-3 text-sm font-semibold text-on-warning-container", children: DEMO_BANNER }));
